import { useEffect, useState } from "react";
import PortalFooter from "../Reactportal/PortalFooter";
import Reactportal from "../Reactportal/Reactportal";
import { useLazyQuery, useQuery } from "@apollo/client";
import "./MultiSectionComponent.scss";
import Loading from "../Loading/Loading";
import { useModalContext } from "../Reactportal/ModalContext";
export const MultiSelectionComponent = ({
  firstLevelQuery,
  secondLevelQuery,
  storeSelectedData,
  show,
  Closeformfunction,
  submit,
  selectedData,
  handleCancle,
}) => {
  // eslint-disable-next-line
  const [openModal, setOpenModal] = useState(show);
  const { pushModal, popModal } = useModalContext();
const Form_Key ="MultiSelectionComponent"
  const [SelectedData, setSelectedData] = useState({ _id: "" });
  const { data, loading } = useQuery(firstLevelQuery, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
    fetchPolicy: "network-only",
  });
  const [SecondLevelQuery, { data: CategoryData }] = useLazyQuery(secondLevelQuery, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
    fetchPolicy: "network-only",
  });
  useEffect(() => {
    if (data?.searchVehicleTypeMasters) HandleClick(data?.searchVehicleTypeMasters[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key)
    }
  }, []);

  const HandleClick = (data) => {
    setSelectedData(data);
    SecondLevelQuery({
      variables: {
        keyword: "",
        vehicleTypeId: data._id,
      },
    }).then((res) => {
      console.log(res);
    });
  };

  return (
    <>
      {openModal && (
        <Reactportal
          open={openModal}
          onClose={() => {
            Closeformfunction();
            handleCancle();
          }}
          TypeOfPortal={""}
          TypeOfId={"Load Id :"}
          UserRightsPortal=""
          id=""
        >
          <div className="MultiSelectContainer">
            {loading ? (
              <Loading />
            ) : (
              <>
                <div className="firstLevelSelect">
                  {data?.searchVehicleTypeMasters?.map((el) => {
                    return (
                      <div
                        className={`${el._id === SelectedData?._id ? "active" : ""}`}
                        onClick={() => {
                          HandleClick(el);
                        }}
                      >
                        <p>{el.Search_Value}</p>
                      </div>
                    );
                  })}
                </div>
                <div className="secondLevelSelect">
                  {CategoryData?.searchVehicleCategory_With_VechileMasters?.map((el) => {
                    return (
                      <div>
                        <p>{el.Search_Value}</p>

                        <input
                          checked={selectedData?.includes(el._id)}
                          type="checkbox"
                          onChange={(e) => storeSelectedData(SelectedData, el, e.target.checked)}
                        />
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>
          <div>
            <PortalFooter
              renderContent={() => <></>}
              submitform={submit}
              submitType={""}
              SaveAndClose={submit}
              handleformclose={() => {
                Closeformfunction();
                // handleCancle();
              }}
              Cancletype={submit ? "Cancel" : "OK"}
              Delete={""}
              handleFileDelete={""}
              UserRightsPortal={""}
              TypeOfPortal={""}
              disableupload={""}
              name={""}
              disabled={false}
              loadingState={""}
              Form_key={Form_Key}
            />
          </div>
        </Reactportal>
      )}
    </>
  );
};
